module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "spinner-list"
  }, _vm._l((_vm.spinners), function(spinner) {
    return _c('div', {
      staticClass: "spinner-container"
    }, [_c(spinner.component, {
      tag: "component",
      attrs: {
        "size": _vm.size
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name",
      domProps: {
        "textContent": _vm._s(spinner.path)
      }
    })])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "header"
  }, [_c('h1', {
    staticClass: "header--title"
  }, [_vm._v("vue-loading-spinner v1.0")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "intro"
  }, [_c('p', [_vm._v("Just another collection of loading spinners with Vue.js, alot of spinners")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://github.com/nguyenvanduocit/vue-loading-spinner"
    }
  }, [_vm._v("Github")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-99701ea0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 156
// module chunks = 1